import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuHistory, LuInfo} from 'react-icons/lu'

export function BatchDrawerTabsList() {
  const {t} = useTranslate('common')

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>
      <Tabs.Trigger value="history" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
